import { useState, useEffect } from "react";
import { Download, X, Share } from "lucide-react";

let deferredPrompt: any = null;

export const InstallPrompt = () => {
	const [show, setShow] = useState(false);
	const [dismissed, setDismissed] = useState(false);

	const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

	useEffect(() => {
		// Don't show if already installed as PWA
		if (window.matchMedia("(display-mode: standalone)").matches) return;
		// Don't show if user dismissed before
		if (localStorage.getItem("pwa-install-dismissed")) return;

		if (isIOS) {
			// iOS doesn't fire beforeinstallprompt, show instructions directly
			setShow(true);
			return;
		}

		const handler = (e: Event) => {
			e.preventDefault();
			deferredPrompt = e;
			setShow(true);
		};

		window.addEventListener("beforeinstallprompt", handler);
		return () => window.removeEventListener("beforeinstallprompt", handler);
	}, [isIOS]);

	if (!show || dismissed) return null;

	const install = async () => {
		if (!deferredPrompt) return;
		deferredPrompt.prompt();
		const { outcome } = await deferredPrompt.userChoice;
		if (outcome === "accepted") {
			setShow(false);
		}
		deferredPrompt = null;
	};

	const dismiss = () => {
		setDismissed(true);
		localStorage.setItem("pwa-install-dismissed", "true");
	};

	return (
		<div className="flex items-center gap-3 px-4 py-2.5 bg-primary/15 border-b border-primary/25 shrink-0">
			<Download size={16} className="text-primary-light shrink-0" />
			{isIOS ? (
				<p className="text-xs text-white/80 flex-1">
					Tap{" "}
					<Share size={12} className="inline-block align-text-bottom text-primary-light" />{" "}
					then &ldquo;Add to Home Screen&rdquo; to install
				</p>
			) : (
				<>
					<p className="text-xs text-white/80 flex-1">
						Install Cheogram for a better experience
					</p>
					<button
						onClick={install}
						className="text-xs font-semibold text-primary-light hover:underline shrink-0"
					>
						Install
					</button>
				</>
			)}
			<button
				onClick={dismiss}
				className="text-white/40 hover:text-white/70 shrink-0"
			>
				<X size={14} />
			</button>
		</div>
	);
};
